<template>
  <div class="solid-border">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="black--text font-weight-medium">{{ title }}</div>
            <div class="mt-2 gray--text">
              {{ subtitle }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="10">
            <div v-if="inputLabel" class="mt-4 mb-n6 black--text">{{ inputLabel }}:</div>

            <div class="d-flex justify-start align-center mt-2">
              <input-field
                v-if="inputLabel || placeholder"
                :placeholder="placeholder"
                close-label
                v-model="email"
              />
              <v-btn
                v-if="useCase === 'send_email'"
                color="black_lighten2"
                outlined
                :class="inputLabel || placeholder ? 'mt-n5 ml-4' : ''"
                @click="buttonClickHandler()"
              >
                <span class="black--text">
                  {{ buttonLabel }}
                </span>
              </v-btn>
              <v-btn
                v-else
                outlined
                :class="inputLabel || placeholder ? 'mt-n5 ml-4' : ''"
                class="info--text pointer"
                @click="buttonClickHandler()"
              >
                {{ buttonLabel }}
              </v-btn>
            </div>

            <v-divider v-if="instructionsLabel" class="my-4" />

            <div v-if="instructionsLabel">
              <div class="black--text">
                {{ instructionsLabel }}
                <v-icon>mdi-info</v-icon>

                <v-icon color="primary" dark :x-small="true" left>mdi-help-circle-outline </v-icon>
              </div>
              <div class="d-flex justify-space-between mt-1">
                <div
                  v-for="(instruction, i) in installationInstructions"
                  :key="i"
                  class="text-caption"
                >
                  <v-tooltip v-if="instruction.text === themeAppBlocks" top>
                    <template #activator="{ on }">
                      <v-icon color="info" :x-small="true" left v-on="on">mdi-information </v-icon>
                    </template>
                    <span>{{ $t('Widgets.onlyForThe') }}</span>
                  </v-tooltip>

                  <a target="_blank" class="text-decoration-none" :href="instruction.link">
                    {{ instruction.text }}
                  </a>

                  <v-icon color="info" :x-small="true" left>mdi-open-in-new </v-icon>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import InputField from '@/components/InputField';
export default {
  name: 'InstallationDialogElement',
  components: { InputField },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    instructionsLabel: {
      type: String,
      default: '',
    },
    inputLabel: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    useCase: {
      type: String,
      default: '',
    },
    instructionsUrl: {
      type: String,
      default: '',
    },
    widgetName: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/require-default-prop
    installationInstructions: {
      type: Array,
    },
  },
  data() {
    return {
      email: null,
      themeAppBlocks: 'Theme app blocks',
    };
  },
  methods: {
    ...mapActions(['trackAnalytics']),
    ...mapActions(['sendInstructionsEmail', 'setReferralEmailContent', 'setReferralLeaderboard']),
    buttonClickHandler() {
      if (this.useCase === 'request_installation') {
        this.$emit('close-dialog');
        this.trackAnalytics('Install Dialog - Live chat');
        this.openChat();
      }
      if (this.useCase === 'via_editor') {
        this.$router.push({ name: 'AdvancedWidgets' });
        this.$emit('close-dialog');
      }
      if (this.useCase === 'via_builder') {
        window.open(
          'https://www.opinew.com/help-center/knowledge-base/using-opinew-with-pagefly-template-editor/',
          '_blank'
        );
      }
      if (this.useCase === 'send_email') {
        const emails = [];
        emails.push(this.email);
        const payload = {
          widget: this.widgetName,
          link: this.instructionsUrl,
          destinations: this.email,
        };
        this.sendInstructionsEmail(payload);
      }
    },
    openChat() {
      window.fcWidget.open();
    },
  },
  computed: {
    ...mapGetters(['segmentObject']),
  },
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.stepsBullets {
  border-radius: 100px;
  height: 16px;
  width: 17px;
  font-size: 8px;
  text-align: center;
}

.stepDone {
  background: #2b64c9;
  color: white;
}

.stepPending {
  background: #bfbfbf;
  color: #707070;
}

.profileName {
  font-size: 16px;
  font-weight: bold;
}

.fbText {
  font-size: 16px;
}

.information {
  display: flex;
  flex-direction: column;
}
.well {
  padding: 20px 20px;
  border-radius: 20px;
}
.list-item:first-child {
  margin: 0;
}
.list-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.button {
  margin: auto;
}

.solid-border {
  border: solid 2px #e5e7e9;
  padding: 15px 22px;
  border-radius: 10px;
}

.pointer {
  cursor: pointer;
}
</style>
